import { Service } from '../types'

export function getSocialNetworkName(service: Service | null): string {
  switch (service) {
    case Service.facebook:
      return 'Facebook'
    case Service.instagram:
    case Service.instagram_login_api:
      return 'Instagram'
    case Service.linkedin:
      return 'LinkedIn'
    case Service.pinterest:
      return 'Pinterest'
    case Service.twitter:
      return 'X'
    case Service.tiktok:
      return 'TikTok'
    case Service.googlebusiness:
      return 'Google Business'
    case Service.mastodon:
      return 'Mastodon'
    case Service.youtube:
      return 'YouTube'
    case Service.threads:
      return 'Threads'
    case Service.bluesky:
      return 'Bluesky'
    case Service.substack:
      return 'Substack'
    default:
      return ''
  }
}
